import React from "react"
import {connect} from "react-redux";
import trans from "trans";

import {checkTokenExpire} from "app/helpers/session"
import {URL} from "app/config/api-config"
import {RouterType, withRouter} from "./routes";

import {
    NavLink,
    confirm,
    Button,
    Icon,
    css,
    Theme,
} from "@bdfx/mergado-ui-kit"

import {setBlockNavigation} from "template-edit/reducers";
import { ConfirmStyles } from "load_styles";


interface Props {
    router: RouterType
    route?: string
    location?: string
    children?: React.JSX.Element
    setLocation?: Function
    exact?: boolean
    className?: string
    close?: Function
    blockNavigation: boolean
    setBlockNavigation: typeof setBlockNavigation
}

export class HeaderLink extends React.PureComponent<Props> {
    constructor(props) {
        super(props)
    }

    showConfirmDialog = () => {
        return confirm({
            title: trans('ask_save_before_leave_title'),
            message: (close) => <div>{trans('ask_save_before_leave')}</div>,
            closeOnClickOutside: true,
            closeOnEscape: true,
            icon: <Icon type={'question-circle'} color={Theme.steelblue} />,
            style: ConfirmStyles,
            buttons: [
                <Button
                    key={'confirm-yes'}
                    color={Theme.red}
                    type='void'
                    style={{margin: '0 20px'}}
                    onClick={() => {
                        this.props.setBlockNavigation(false)
                        this.processRoute()
                    }}>
                    {trans("ask_save_before_leave_leave")}
                </Button>,
                <Button
                    key={'confirm-no'}
                    color={Theme.green}
                    type='void'
                    style={{margin: '0 20px'}}
                    onClick={() => close()}>
                    {trans("ask_save_before_leave_stay")}
                </Button>
            ]
        })
    }

    processRoute = () => {
        checkTokenExpire(this.props.route)
        this.props.router.navigate(this.props.route)
        this.props.close()
    }

    onClick = e => {
        e.preventDefault()

        if (this.props.blockNavigation) {
            this.showConfirmDialog()
        } else {
            this.processRoute()
        }

        return false
    }

    getLink = () => {
        const {route} = this.props
        return `${URL.publicPath}${route && route[0] === "/" ? route.substr(1) : route}`
    }

    public render() {
        const { route, children, location, exact, className } = this.props
        const isActive = route ? (exact !== undefined ? location === `${route}` : location.indexOf(route) > -1) : false
        const link = this.getLink()

        return <NavLink
            active={isActive}
            className={className || ''}
            link={route ? <a onClick={(e) => this.onClick(e)} href={link}>{children}</a> : <span>{children}</span>}
        />
    }
}

function mapStateToProps(state, props) {
    return {
        blockNavigation: state.blockNavigation,
    }
}

export default connect(mapStateToProps, {
    setBlockNavigation,
})(withRouter(HeaderLink));
